import { createFileRoute } from '@tanstack/react-router';
import { PaymentsPage } from '@/features/finance';

export const Route = createFileRoute('/_auth/o/$orgId/finance/payments')({
  component: PaymentsRoute,
});

function PaymentsRoute() {
  const { orgId } = Route.useParams();
  return <PaymentsPage orgId={orgId} />;
}
